import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MODAL_REF, ModalRef } from '@services/components/ModalService/modal.ref';

@Component({
  selector: 'app-generic-error-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="generic-error-modal">
      <p class="generic-error-modal__description">
        Si el problema persiste, intenta nuevamente más tarde.
      </p>
      <div class="generic-error-modal__actions">
        <button
          class="btn btn-primary"
          type="button"
          (click)="onRetry()">
          Reintentar
        </button>
      </div>
    </div>
  `,
  styles: [`
    .generic-error-modal__description {
      font-family: 'Space Mono', monospace;
      font-size: 0.875rem;
      color: var(--text-dark);
      margin: 0 0 1.5rem;
      line-height: 1.6;
    }

    .generic-error-modal__actions {
      display: flex;
      justify-content: flex-end;
    }

    .btn {
      padding: 0.6rem 1.4rem;
      font-family: 'Space Mono', monospace;
      font-size: 0.875rem;
      font-weight: 700;
      border: 2px solid var(--text-dark);
      cursor: pointer;
      transition: transform 0.15s ease, box-shadow 0.15s ease;
    }

    .btn:hover {
      transform: translate(-2px, -2px);
      box-shadow: 4px 4px 0 var(--text-dark);
    }

    .btn-primary {
      background-color: var(--accent-red);
      color: #ffffff;
    }
  `],
})
export class GenericErrorModalComponent {
  private readonly modalRef = inject(MODAL_REF) as ModalRef<void>;

  public onRetry(): void {
    this.modalRef.close({ reason: 'confirm' });
  }
}
